export const featuredProjectsParallax = () => {
  const featuredProjects = document.querySelectorAll('.c-featured-project');

  if (featuredProjects.length === 0) {
    return;
  }

  if (window.main?.featuredProjectsParallaxCleanup) {
    window.main.featuredProjectsParallaxCleanup();
  }

  const isTouchDevice = 'ontouchstart' in window || (window.DocumentTouch && document instanceof DocumentTouch);
  if (isTouchDevice) {
    return;
  }

  const scrollHandlers = [];

  const init = () => {
    featuredProjects.forEach((project) => {
      const cover = project.querySelector('.c-featured-project__cover');
      const imageContainer = cover?.querySelector('.c-cover-media, .m-image-container');
      // Transform the parallax wrapper, not the <img> (avoids GPU bitmap discard on scroll)
      const parallaxLayer =
        imageContainer?.querySelector('.c-cover-media__parallax') ||
        imageContainer?.querySelector('.o-image, .o-video, video');

      if (!cover || !imageContainer || !parallaxLayer) {
        return;
      }

      // Store initial values
      const coverRect = cover.getBoundingClientRect();
      const coverTop = coverRect.top + window.scrollY;
      const coverHeight = cover.offsetHeight;
      
      // Set up parallax on scroll
      const handleScroll = () => {
        const scrollY = window.scrollY;
        const windowHeight = window.innerHeight;
        
        // Calculate if cover is in viewport
        const coverBottom = coverTop + coverHeight;
        const viewportTop = scrollY;
        const viewportBottom = scrollY + windowHeight;
        
        // Only apply parallax when cover is in or near viewport
        if (coverBottom > viewportTop && coverTop < viewportBottom) {
          // Calculate how much of the cover is visible
          const coverTopInViewport = Math.max(0, viewportTop - coverTop);
          
          // Calculate scroll progress (0 when cover enters viewport, 1 when it leaves)
          // Parallax moves image slower than scroll (creating depth effect)
          const scrollProgress = coverTopInViewport / (coverHeight + windowHeight);
          
          // Parallax offset: as we scroll down, image moves up slightly (negative Y)
          // Adjust the multiplier (0.2) to change intensity - higher = more movement
          const parallaxOffset = scrollProgress * coverHeight * 0.2;
          
          // Apply transform to wrapper (only Y-axis parallax)
          parallaxLayer.style.transform = `translate3d(0, ${parallaxOffset}px, 0)`;
        }
        /* Keep last transform when off-screen — resetting forces a repaint on scroll-back */
      };

      // Throttle scroll events for performance
      let ticking = false;
      const throttledScroll = () => {
        if (!ticking) {
          window.requestAnimationFrame(() => {
            handleScroll();
            ticking = false;
          });
          ticking = true;
        }
      };

      window.addEventListener('scroll', throttledScroll, { passive: true });
      scrollHandlers.push(throttledScroll);

      // Initial call
      handleScroll();
    });
  };

  window.main = window.main || {};
  window.main.featuredProjectsParallaxCleanup = () => {
    scrollHandlers.forEach((handler) => {
      window.removeEventListener('scroll', handler);
    });
    scrollHandlers.length = 0;
  };

  init();
};

